// 微信跳转管理器 - 增强版
// 支持保存跳转路径，避免重复授权

// 保存微信跳转信息
export const saveWechatJumpInfo = (info) => {
    try {
        const jumpInfo = {
            ...info,
            timestamp: Date.now(),
            currentPath: window.location.pathname + window.location.search
        };
        localStorage.setItem('wechatJumpInfo', JSON.stringify(jumpInfo));
        console.log('💾 保存微信跳转信息:', jumpInfo);
    } catch (error) {
        console.error('保存微信跳转信息失败:', error);
    }
};

// 获取微信跳转信息
export const getWechatJumpInfo = () => {
    try {
        const info = localStorage.getItem('wechatJumpInfo');
        return info ? JSON.parse(info) : null;
    } catch (error) {
        console.error('获取微信跳转信息失败:', error);
        return null;
    }
};

// 清除微信跳转信息
export const clearWechatJumpInfo = () => {
    try {
        localStorage.removeItem('wechatJumpInfo');
        console.log('🧹 清除微信跳转信息');
    } catch (error) {
        console.error('清除微信跳转信息失败:', error);
    }
};

// 设置跳转标记
export const setRedirectingFlag = (type) => {
    try {
        localStorage.setItem(`isRedirectingTo${type}`, '1');
        console.log(`🚩 设置跳转标记: isRedirectingTo${type}`);
    } catch (error) {
        console.error('设置跳转标记失败:', error);
    }
};

// 清除跳转标记
export const clearRedirectingFlag = (type) => {
    try {
        localStorage.removeItem(`isRedirectingTo${type}`);
        console.log(`🧹 清除跳转标记: isRedirectingTo${type}`);
    } catch (error) {
        console.error('清除跳转标记失败:', error);
    }
};

// 检查是否正在跳转
export const isRedirecting = (type) => {
    try {
        return localStorage.getItem(`isRedirectingTo${type}`) === '1';
    } catch (error) {
        console.error('检查跳转状态失败:', error);
        return false;
    }
};

// 保存授权重定向路径
export const saveAuthRedirectPath = (path) => {
    try {
        // 检查页面是否需要微信授权
        if (!needsWechatAuth(path)) {
            console.log('🔍 saveAuthRedirectPath: 页面不需要微信授权，不保存路径:', path);
            return false;
        }
        
        const fullPath = ensureFullPath(path);
        localStorage.setItem('returnUrl', fullPath);
        console.log('💾 saveAuthRedirectPath: 保存授权重定向路径到returnUrl:', fullPath);
        return true;
    } catch (error) {
        console.error('❌ saveAuthRedirectPath: 保存失败:', error);
        return false;
    }
};

// 获取授权重定向路径
export const getAuthRedirectPath = () => {
    try {
        const path = localStorage.getItem('returnUrl');
        if (!path) {
            console.log('🔍 getAuthRedirectPath: 未找到保存的重定向路径');
            return null;
        }
        
        const redirectInfo = {
            path: path,
            timestamp: Date.now()
        };
        
        console.log('🔍 getAuthRedirectPath: 获取到重定向路径:', path);
        return redirectInfo;
    } catch (error) {
        console.error('❌ getAuthRedirectPath: 获取失败:', error);
        return null;
    }
};

// 清除授权重定向路径
export const clearAuthRedirectPath = () => {
    try {
        localStorage.removeItem('returnUrl');
        console.log('🧹 clearAuthRedirectPath: 已清除重定向路径');
        return true;
    } catch (error) {
        console.error('❌ clearAuthRedirectPath: 清除失败:', error);
        return false;
    }
};

// 检查是否应该跳过微信授权
export const shouldSkipWechatAuth = () => {
    try {
        console.log('🔍 shouldSkipWechatAuth: 开始检查是否应该跳过微信授权');
        // 检查是否在微信浏览器
        const isWechat = /MicroMessenger/i.test(navigator.userAgent);
        if (!isWechat) {
            console.log('🔍 非微信环境，不进行授权检查');
            return false;
        }
        console.log('📱 确认在微信环境中，继续检查跳转逻辑');
        
        // 检查是否已经有微信用户信息（已授权成功）
        const wechatUserStr = localStorage.getItem('wechatUser');
        if (wechatUserStr) {
            try {
                const wechatUser = JSON.parse(wechatUserStr);
                if (wechatUser && wechatUser.openid) {
                    console.log('✅ 检测到已授权用户:', wechatUser.nickname || wechatUser.openid);
                    console.log('🧹 删除跳转路径，不进行跳转和授权');
                    clearAuthRedirectPath();
                    return false;
                }
            } catch (error) {
                console.log('⚠️ 解析wechatUser失败，继续检查跳转逻辑');
            }
        }
        
        // 获取保存的跳转路径
        const redirectInfo = getAuthRedirectPath();
        if (!redirectInfo) {
            console.log('🔍 无保存的跳转路径，不跳过授权');
            return false;
        }
        
        const currentPath = window.location.pathname + window.location.search;
        console.log('📍 当前路径:', currentPath);
        console.log('📍 保存的跳转路径:', redirectInfo.path);
        
        // 标准化路径比较（去除末尾的斜杠）
        const normalizePath = (path) => {
            return path === '/' ? '/forms' : path.replace(/\/$/, '');
        };
        
        const normalizedCurrentPath = normalizePath(currentPath);
        const normalizedRedirectPath = normalizePath(redirectInfo.path);
        
        console.log('📍 标准化当前路径:', normalizedCurrentPath);
        console.log('📍 标准化跳转路径:', normalizedRedirectPath);
        
        // 如果跳转路径与当前路径相同，说明已经到达目标页面，不需要跳转
        if (normalizedRedirectPath === normalizedCurrentPath) {
            console.log('✅ 跳转路径与当前路径相同，已到达目标页面');
            console.log('🧹 清除跳转路径，避免重复使用');
            clearAuthRedirectPath();
            return false;
        }
        
        // 特殊处理：如果当前在表单列表页面，且跳转路径是根路径，也不进行跳转
        if ((currentPath === '/forms' || currentPath === '/') && redirectInfo.path === '/') {
            console.log('✅ 当前已在表单列表页面，跳转路径也是根路径，不进行跳转');
            console.log('🧹 清除跳转路径，避免重复使用');
            clearAuthRedirectPath();
            return false;
        }
        
        console.log('⏭️ 检测到可跳转路径，应该跳过授权直接跳转');
        return true;
    } catch (error) {
        console.error('❌ shouldSkipWechatAuth 检查失败:', error);
        return false;
    }
};

// 执行智能跳转
export const performSmartRedirect = () => {
    try {
        console.log('🚀 performSmartRedirect: 开始执行智能跳转');
        
        // 检查是否已经在处理跳转，避免重复处理
        const isProcessing = localStorage.getItem('isProcessingWechatAuth');
        if (isProcessing) {
            console.log('🔍 已在处理微信授权，跳过重复跳转');
            return false;
        }
        
        const redirectInfo = getAuthRedirectPath();
        if (!redirectInfo) {
            console.log('❌ 没有保存的跳转路径，无法执行跳转');
            return false;
        }
        
        console.log('🚀 执行智能跳转到:', redirectInfo.path);

        // 设置处理标记，防止重复跳转
        localStorage.setItem('isProcessingWechatAuth', '1');

        // 构造带 jump=1 的跳转地址
        let urlWithJump = redirectInfo.path;
        try {
            const targetUrl = new URL(redirectInfo.path, window.location.origin);
            targetUrl.searchParams.set('jump', '1');
            urlWithJump = targetUrl.toString();
        } catch (composeError) {
            // 兼容非常规的相对路径或无法被 URL 解析的情况
            const separator = redirectInfo.path.includes('?') ? '&' : '?';
            urlWithJump = `${redirectInfo.path}${separator}jump=1`;
            console.warn('⚠️ 生成 URL 对象失败，已采用字符串方式拼接 jump 参数:', composeError);
        }

        // 立即执行跳转
        console.log('🚀 performSmartRedirect: 跳转到:', urlWithJump);
        window.location.href = urlWithJump;
        
        return true;
    } catch (error) {
        console.error('❌ performSmartRedirect: 执行失败:', error);
        return false;
    }
};

// 检查并处理微信授权前的准备工作
export const prepareWechatAuth = (fromPage = 'unknown') => {
    try {
        console.log('🔍 检查微信授权前准备:', fromPage);
        
        // 如果应该跳过授权，直接执行跳转
        if (shouldSkipWechatAuth()) {
            console.log('✅ 检测到可跳过的授权，执行智能跳转');
            return performSmartRedirect();
        }

        // 保存当前页面作为授权成功后的跳转目标
        const currentPath = window.location.pathname + window.location.search;
        saveAuthRedirectPath(currentPath);
        
        console.log('💾 已保存当前页面作为跳转目标:', currentPath);
        return false; // 不跳过授权
    } catch (error) {
        console.error('准备微信授权失败:', error);
        return false;
    }
};

// 判断页面是否需要微信授权
export const needsWechatAuth = (path) => {
    if (!path) return false;
    
    try {
        // 解析路径
        const url = new URL(path.startsWith('http') ? path : window.location.origin + path);
        const pathname = url.pathname;
        
        // 不需要微信授权的页面列表
        const noAuthPages = [
            '/forms',           // 表单列表页面
            '/',               // 根页面（表单列表）
            '/wechat-auth',    // 微信授权页面本身
            '/wechat-auth-test' // 测试页面
        ];
        
        // 需要微信授权的页面特征
        const authRequiredPatterns = [
            /^\/detail\//,     // 表单详情页面
            /^\/fill\//,       // 表单填写页面
            /^\/black-card/,   // 黑卡相关页面
            /^\/wechat-auth$/  // 微信授权页面（虽然不需要保存，但需要授权）
        ];
        
        // 检查是否在不需要授权的页面列表中
        if (noAuthPages.includes(pathname)) {
            console.log('🔍 needsWechatAuth: 页面不需要微信授权:', pathname);
            return false;
        }
        
        // 检查是否匹配需要授权的页面模式
        for (const pattern of authRequiredPatterns) {
            if (pattern.test(pathname)) {
                console.log('🔍 needsWechatAuth: 页面需要微信授权:', pathname);
                return true;
            }
        }
        
        // 默认情况下，如果不在明确的不需要授权列表中，则认为是需要授权的
        console.log('🔍 needsWechatAuth: 页面默认需要微信授权:', pathname);
        return true;
    } catch (error) {
        console.error('❌ needsWechatAuth: 判断失败:', error);
        return false;
    }
};

// 工具函数：确保路径是完整路径
export const ensureFullPath = (path) => {
    if (!path) return window.location.origin + '/';
    
    try {
        // 如果已经是完整URL，直接返回
        if (path.startsWith('http')) {
            return path;
        }
        
        // 如果是相对路径，转换为完整路径
        if (path.startsWith('/')) {
            return window.location.origin + path;
        }
        
        // 其他情况，确保是完整路径
        return window.location.origin + '/' + path;
    } catch (error) {
        console.error('❌ 路径转换失败:', error);
        return window.location.origin + '/';
    }
};

// 保存授权目标路径（用于跳过授权判断）
export const saveAuthTargetPath = (path, info = {}) => {
    try {
        // 检查页面是否需要微信授权
        if (!needsWechatAuth(path)) {
            console.log('🔍 saveAuthTargetPath: 页面不需要微信授权，不保存路径:', path);
            return false;
        }
        
        // 确保保存的是完整路径
        const fullPath = ensureFullPath(path);
        
        // eslint-disable-next-line no-unused-vars
        const targetInfo = {
            path: fullPath,
            timestamp: Date.now(),
            ...info
        };
        localStorage.setItem('returnUrl', fullPath);
        console.log('💾 saveAuthTargetPath: 保存目标路径到returnUrl:', fullPath);
        return true;
    } catch (error) {
        console.error('❌ saveAuthTargetPath: 保存失败:', error);
        return false;
    }
};

// 获取授权目标路径
export const getAuthTargetPath = () => {
    try {
        const path = localStorage.getItem('returnUrl');
        if (!path) {
            console.log('🔍 getAuthTargetPath: 未找到保存的目标路径');
            return null;
        }
        
        const targetInfo = {
            path,
            timestamp: Date.now()
        };
        
        console.log('🔍 getAuthTargetPath: 获取到目标路径:', path);
        return targetInfo;
    } catch (error) {
        console.error('❌ getAuthTargetPath: 获取失败:', error);
        return null;
    }
};

// 获取授权目标路径（兼容函数）
export const getAuthTargetPathCompat = () => {
    return getAuthTargetPath();
};

// 清除授权目标路径
export const clearAuthTargetPath = () => {
    try {
        localStorage.removeItem('returnUrl');
        console.log('🧹 clearAuthTargetPath: 已清除目标路径');
        return true;
    } catch (error) {
        console.error('❌ clearAuthTargetPath: 清除失败:', error);
        return false;
    }
};

// 新增：获取授权目标信息（兼容旧版本）
export const getAuthTargetInfo = () => {
    return getAuthTargetPath();
};

// 新增：检查是否应该跳过授权并跳转（兼容旧版本）
export const shouldSkipAuthAndJump = () => {
    return shouldSkipWechatAuth();
};

// 新增：执行授权目标跳转（兼容旧版本）
export const executeAuthTargetJump = () => {
    return performSmartRedirect();
};

// 新增：清除授权目标信息（兼容旧版本）
export const clearAuthTargetInfo = () => {
    try {
        localStorage.removeItem('returnUrl');
        console.log('🧹 清除授权目标信息');
    } catch (error) {
        console.error('清除授权目标信息失败:', error);
    }
}; 